import { BASE } from "../api/client";

export async function login({ identifier, password }) {
  // Compatible backend standard (username) + backend custom (email)
  const body = {
    username: identifier,
    email: identifier,
    password,
  };

  const res = await fetch(`${BASE}/api/auth/token/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  // Lire la réponse 1 seule fois
  const payload = await res.json().catch(() => ({}));

  if (!res.ok) {
    console.log("Login error:", payload);
    throw new Error(
      payload.detail ||
        payload.non_field_errors?.[0] ||
        payload.username?.[0] ||
        payload.email?.[0] ||
        payload.password?.[0] ||
        "Identifiants incorrects"
    );
  }

  localStorage.setItem("access", payload.access);
  localStorage.setItem("refresh", payload.refresh);
  localStorage.setItem("isLoggedIn", "true");

  localStorage.setItem("accessToken", payload.access);
  localStorage.setItem("refreshToken", payload.refresh);

  return payload;
}

export async function register({ email, password, username }) {
  const token =
    localStorage.getItem("accessToken") || localStorage.getItem("access");

  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE}/api/auth/register/`, {
    method: "POST",
    headers,
    body: JSON.stringify({ email, password, username }),
  });

  const payload = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(
      payload.detail ||
        payload.non_field_errors?.[0] ||
        payload.email?.[0] ||
        payload.username?.[0] ||
        payload.password?.[0] ||
        "Erreur inscription"
    );
  }

  return payload;
}

export async function logout() {
  const access = localStorage.getItem("access");
  const refresh = localStorage.getItem("refresh");

  if (access && refresh) {
    await fetch(`${BASE}/api/auth/logout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      body: JSON.stringify({ refresh }),
    }).catch(() => {});
  }

  localStorage.clear();
}
